export enum WORKSTATION_FILTER {
  ALL = 'all',
  ASSIGNED = 'assigned',
  ASSIGNED_MINE = 'assigned_mine',
}

export enum SORT_BY {
  NAME = 'name',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
}

export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
}
